import React from "react";
import AddNewStaffPage from "../../../../../entities/DashboardPage/AccountingModule/StaffPage/AddNewStaffPage";

const AddNewStaff = () => {
  return(
    <AddNewStaffPage/>
  )
}

export default AddNewStaff